var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"80vh"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.imgSrc,"alt":"logo website","width":"170px","height":"170px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }